import React from "react";
import Footer from "./Footer";

const AboutPage = ({store}) => {
  return (
    <>
      <div className="container-fluid aPage text-center">
        <div className="row">
          <h3>ABOUT US</h3>
          <div className="apTextWrap">
          {<pre className="about-top-description" dangerouslySetInnerHTML={{__html: store.about_text}}></pre> }
            {/* <p>
              Founded by entrepreneurs Ahdy Khalil and Brian Lalji, Zinc Group
              is a Hong Kong based hospitality group specializing in providing
              bold, innovative and alluring experiences in the heart of
              entertainment districts.
            </p>
            <p>
              Since our inception in 2007, Zinc Group has been deeply focused on
              creating and delivering original concepts that combine elements of
              music, dining and entertainment into one.
            </p>
            <p>
              With an eye on exceptional service and guest satisfaction, Zinc
              Group HK is always pushing boundaries and expanding across Hong
              Kong and beyond.
            </p> */}
          </div>
        </div>
      </div>
      <div className="footer d-lg-none">
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
